import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Autocomplete, CustomTextField } from "@totalsoft/rocket-webapp-components-deprecated";
import clientPageStyle from "../styles";
import { useTranslation } from "react-i18next";
import { Card, Grid, IconButton, makeStyles, Tooltip, Typography } from "@material-ui/core";
import { Search, DeleteSweepRounded } from "@material-ui/icons";
import { get, set } from "@totalsoft/react-state-lens";
import { emptyArray, emptyString } from "constants/defaultValues";
import { useQueryWithErrorHandling } from "hooks/errorHandling";
import { GET_DICTIONARY } from "features/common/queries";
import cx from "classnames";

const useStyles = makeStyles(clientPageStyle);

function ColesseeContainer(props) {
  const { index, quotePartnerLens, onRemove, onAdd } = props;
  const { t } = useTranslation();
  const classes = useStyles();

  const { data } = useQueryWithErrorHandling(GET_DICTIONARY, { variables: { dictionaryName: "PartnerRoles" } });
  const partnerRoles = data?.dictionary || emptyArray;

  const quotePartner = quotePartnerLens |> get;

  const handleAdd = useCallback(() => onAdd(index), [onAdd, index]);
  const handleRemove = useCallback(() => onRemove(index), [onRemove, index]);

  const renderAutocomplete = useCallback(
    (params) => {
      return (
        <CustomTextField
          {...params}
          fullWidth
          InputProps={{
            ...params.InputProps,
            classes: {
              input: classes.autocomplete,
              underline: classes.underline,
            },
          }}
        />
      );
    },
    [classes]
  );

  return (
    <Card id={"colesseeCard" + index} className={classes.card}>
      <Grid container>
        <Grid item xs={12} lg={2} className={classes.partnerSection} container alignItems="center">
          <div className={classes.arrowTipItem}>
            <Typography
              variant="caption"
              component="div"
              className={cx(classes.partnerName, classes.partnerNameWithRoles)}
            >
              {quotePartner?.name || emptyString}
            </Typography>
            <div className={classes.flexDisplay}>
              <Typography variant="caption" component="div" className={classes.partnerRole}>
                {t("Client.Role")}
              </Typography>
              <Autocomplete
                label={emptyString}
                labelKey="name"
                valueKey="id"
                simpleValue
                options={index > 0 ? partnerRoles.filter((r) => r.id != -1) : partnerRoles}
                onChange={quotePartnerLens?.roleId |> set}
                value={quotePartner?.roleId}
                classes={{ popupIndicator: classes.colorWhite }}
                renderInput={renderAutocomplete}
                className={classes.width80}
                disabled={index === 0}
                noOptionsText={t("General.AutocompleteNoOptions")}
              />
            </div>
          </div>
        </Grid>
        <Grid item container xs={12} lg={10} direction="column" justifyContent="center" className={classes.partnerData}>
          <Grid
            item
            container
            xs={10}
            justifyContent="space-between"
            alignItems="center"
            className={classes.paddingLeft15}
          >
            <Grid item xs>
              <Typography className={classes.minFont}>{t("Client.CityOrState")}</Typography>
              <Typography className={classes.reducedFont}>{`${
                (quotePartner?.city || "") + ((quotePartner?.state && " (" + quotePartner?.state + ")") || "")
              }`}</Typography>
            </Grid>
            <Grid item xs>
              <Typography className={classes.minFont}>{t("Client.Address")}</Typography>
              <Typography className={classes.reducedFont}>{quotePartner?.address}</Typography>
            </Grid>
            <Grid item xs>
              <Typography className={classes.minFont}>{t("Client.Zip")}</Typography>
              <Typography className={classes.reducedFont}>{quotePartner?.zip}</Typography>
            </Grid>
            <Grid item xs>
              <Typography className={classes.minFont}>{t("Client.Phone")}</Typography>
              <Typography className={classes.reducedFont}>{quotePartner?.phone}</Typography>
            </Grid>
            <Grid item xs>
              <Typography className={classes.minFont}>{t("Client.TaxIdNumber")}</Typography>
              <Typography className={classes.reducedFont}>{quotePartner?.taxId}</Typography>
            </Grid>
          </Grid>
          <Grid item container xs={2} justifyContent="flex-end">
            <IconButton onClick={handleAdd} variant="outlined">
              <Tooltip title={t("General.Select")} placement="top">
                <Search fontSize="small" />
              </Tooltip>
            </IconButton>
            <IconButton onClick={handleRemove} variant="outlined" disabled={index === 0}>
              <Tooltip title={t("General.DeleteItem")} placement="top">
                <DeleteSweepRounded fontSize="small" />
              </Tooltip>
            </IconButton>
          </Grid>
        </Grid>
      </Grid>
    </Card>
  );
}

ColesseeContainer.propTypes = {
  index: PropTypes.number.isRequired,
  quotePartnerLens: PropTypes.object.isRequired,
  onRemove: PropTypes.func.isRequired,
  onAdd: PropTypes.func.isRequired,
};

export default ColesseeContainer;
